import { Box, Stack } from '@mui/material';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import {
  PrimaryButton,
  WarningButton,
} from '../../../components/style/ButtonStyle';
import { CommonDivider } from '../../../components/style/CommonStyle';
import {
  DetailInfoText,
  FormLabelText,
  FormTitle,
} from '../../../components/style/TextStyle';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import useResponsive from '../../../hooks/useResponsive';
import {
  UserRoleListLabel,
  responsiveMargin,
  responsiveSpacing,
} from '../../../utils/enum';
import { slicePhone } from '../../../utils/helper';

export default function MyAccountPage() {
  const navigate = useNavigate();
  const mdUp = useResponsive('up', 'md');

  const [getMeResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/user/who-am-i`,
    },
    { manual: false },
  );

  const me = _.get(getMeResult, 'response.data');

  return (
    <Stack mx={responsiveMargin} spacing={5} mt={{ xs: 2, md: 10 }} mb={5}>
      <Stack
        direction={{ xs: 'row', md: 'column' }}
        spacing={{ xs: 0, md: 5 }}
        justifyContent={{ xs: 'center', md: 'space-between' }}
        alignItems={{ xs: 'center', md: 'flex-start' }}
      >
        {mdUp ? <DesktopHeader /> : <FormTitle>내 계정 정보</FormTitle>}
      </Stack>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={3}
      >
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>
            ID<span>*</span>
          </FormLabelText>
          <DetailInfoText>{me?.id || '-'}</DetailInfoText>
        </Stack>
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>
            이름<span>*</span>
          </FormLabelText>
          <DetailInfoText>{me?.name || '-'}</DetailInfoText>
        </Stack>
      </Stack>
      <CommonDivider />
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={3}
      >
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>
            이메일 주소<span>*</span>
          </FormLabelText>
          <DetailInfoText>{me?.email || '-'}</DetailInfoText>
        </Stack>
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>
            연락처<span>*</span>
          </FormLabelText>
          <DetailInfoText>{slicePhone(me?.phone || '-')}</DetailInfoText>
        </Stack>
      </Stack>
      <CommonDivider />
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={3}
      >
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>행정동</FormLabelText>
          <DetailInfoText>{me?.administrativeRegion || '-'}</DetailInfoText>
        </Stack>
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>소속과</FormLabelText>
          <DetailInfoText>{me?.departmentTitle || '-'}</DetailInfoText>
        </Stack>
        <Stack spacing={responsiveSpacing} sx={{ flex: 1 }}>
          <FormLabelText>권한</FormLabelText>
          <DetailInfoText>
            {_.get(UserRoleListLabel, me?.role, '-')}
          </DetailInfoText>
        </Stack>
      </Stack>
      {mdUp ? (
        <></>
      ) : (
        <Stack direction="row" spacing={1}>
          <WarningButton>계정 삭제</WarningButton>
          <PrimaryButton onClick={() => navigate(`/users/:userId/form`)}>
            계정 수정
          </PrimaryButton>
        </Stack>
      )}
    </Stack>
  );
}

function DesktopHeader() {
  const navigate = useNavigate();
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: '100% !important' }}
      >
        <FormTitle>내 계정 정보</FormTitle>
        <Box />
        <Stack direction="row" spacing={1}>
          <WarningButton sx={{ width: 130, height: 40 }}>
            계정 삭제
          </WarningButton>
          <PrimaryButton
            sx={{ width: 206, height: 40 }}
            onClick={() => navigate(`/users/:userId/form`)}
          >
            계정 수정
          </PrimaryButton>
        </Stack>
      </Stack>
      <CommonDivider />
    </>
  );
}
